
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUGenerationGrid extends Serenity.EntityGrid<SKUGenerationRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUGeneration'; }
        protected getDialogType() { return SKUGenerationDialog; }
        protected getIdProperty() { return SKUGenerationRow.idProperty; }
        protected getInsertPermission() { return SKUGenerationRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUGenerationRow.localTextPrefix; }
        protected getService() { return SKUGenerationService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(52);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[52].AutoPosting;
            this.editItem(<SKUGenerationRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId:userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 52,
                AutoPosting: autoposting

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}